import { Environment } from './environment.model';

export const environment: Environment = {
    production: true,
    recaptchaSiteKey: '6Ldo0k0qAAAAAJv9GCaaTqulEFOmqgURYqVb3Ylh',
    features: [],
};
